import { faDogLeashed, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActivityTimeline } from 'components/Activities/Timeline/ActivityTimelineProvider';
import styles from 'components/Activities/Timeline/EmptyState/ActivityTimelineEmptyState.module.scss';
import Button from 'components/UI/V3/Button/Button';
import React from 'react';

export const ActivityTimelineEmptyState: React.FC<{ readOnly?: boolean }> = ({ readOnly }) => {
    const { isPetEnabled, openActivityForm } = useActivityTimeline();
    const isReadOnly = readOnly ?? false;

    return (
        <div className={styles.root}>
            <div className={styles.icon}>
                <FontAwesomeIcon icon={faDogLeashed} />
            </div>

            <h2 className={styles.title}>Activities</h2>
            <p>Click the “Add Activity” button to add your first one</p>

            <Button
                leftIcon={faPlus}
                label="Add Activity"
                disabled={!isPetEnabled || isReadOnly}
                onClick={() => !isReadOnly && openActivityForm()}
            />
        </div>
    );
};
